import moment from "moment";
import { API_BASE_URL, FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function getListTipoVehiculo(obj, combo = false, tag) {
    try {
        let data = [];
        const { code, body } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/tipo-vehiculo/list-tipo-vehiculo",
            API_BASE_URL + "/tipo-vehiculo/list-tipo-vehiculo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
            if (combo === false) {
                for (let i = 0; i < data.length; i++) {
                    data[i].fechamodificacion = moment(data[i].fechaModificacion).format("DD/MM/YYYY HH:mm");
                    data[i].habilitadolabel = data[i].habilitado === 1 ? tag("label_yes") : tag("label_no");
                }
            }
            if (combo === true) {
                data = data.map((item) => {
                    return {
                        value: item.id,
                        label: item.descripcion,
                    };
                });
            }
        }
        return data;
    } catch (err) {
        console.log("getListTipoVehiculo err");
        console.log(err);
        return [];
    }
}

export async function createTipoVehiculo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/tipo-vehiculo/create-tipo-vehiculo",
            API_BASE_URL + "/tipo-vehiculo/create-tipo-vehiculo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("createTipoVehiculo err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function disableTipoVehiculo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/tipo-vehiculo/disable-tipo-vehiculo",
            API_BASE_URL + "/tipo-vehiculo/disable-tipo-vehiculo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("disableTipoVehiculo err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function enableTipoVehiculo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/tipo-vehiculo/enable-tipo-vehiculo",
            API_BASE_URL + "/tipo-vehiculo/enable-tipo-vehiculo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("enableTipoVehiculo err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function updateTipoVehiculo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/tipo-vehiculo/update-tipo-vehiculo",
            API_BASE_URL + "/tipo-vehiculo/update-tipo-vehiculo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("updateTipoVehiculo err");
        console.log(err);
        return { error: true, message: err };
    }
}